/**
 * Checks whether the stored access token is expired.
 *
 * @param rawToken The raw token string
 */
export function isTokenExpired(rawToken: string) {
  try {
    const payload = JSON.parse(atob(rawToken.split(".")[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp <= now;
  } catch {
    return true;
  }
}
